// Generated by scripts/update-seeq-icons.js from src/svg/seeq/short-dash-dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcShortDashDot = {
  prefix: 'fak',
  iconName: 'short-dash-dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f903',
    'M230.4 512h327.7v46.1h-327.7v-46.1zM41 465.9h92.1v46.1h-92.1v-46.1zM230.4 465.9h327.7v46.1h-327.7v-46.1zM655.4 465.9h92.1v46.1h-92.1v-46.1zM655.4 512h92.1v46.1h-92.1v-46.1zM41 512h92.1v46.1h-92.1v-46.1zM844.8 465.9h179.2v46.1h-179.2v-46.1zM844.8 512h179.2v46.1h-179.2v-46.1z',
  ],
} satisfies IconDefinition;
